import { graphql } from 'react-relay';

export const addressFragment = graphql`
    fragment Address_address on Address {
        companyName
        street
        postCode
        city
        country
        phone
        fax
        email
    }
`;
